import { Channel } from 'Listrak.Customer.Segmentation.Api.V2.Client';
import { match, P } from 'ts-pattern';

export default function(channel: Channel): string {
    return match(channel)
        .with(Channel.AppPush, () => 'App Push')
        .with(Channel.WebPush, () => 'Web Push')
        .with(Channel.TikTokAudience, () => 'TikTok')
        .with(P._, () => channel)
        .exhaustive();
}
